import type {
	BeneficiaryPayload,
	ComputedBeneficiaryPayload,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryFetched';
import computeBeneficiaryPayload from '@Application/Beneficiaries/Beneficiaries/Actions/computeBeneficiaryPayload';

export type BeneficiaryCreatedAction = {
	type: 'BENEFICIARY_CREATED';
	payload: ComputedBeneficiaryPayload;
	facilityId: number;
};

export default (payload: BeneficiaryPayload, facilityId: number): BeneficiaryCreatedAction => ({
	type: 'BENEFICIARY_CREATED',
	payload: computeBeneficiaryPayload(payload),
	facilityId,
});
